import React, { Component } from 'react';

class Loading extends Component {
    render() {
        return(
            <div className="loading">
              <span></span>
            </div>
        );
    }
}

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Containers/Loading/index.js